import ExchangeList from "../../components/ExchangeList";

function Stock() {
  return (
    <ExchangeList instrument="stock" />
  );
}

export default Stock;
